import { IncidenceDetailsField } from 'modules/payroll_bundle/lib/types'
import {
  booleanModifier,
  dateModifier,
  displayCotizationGroup,
  salaryCurrencyFrequencyModifier,
  weekdaysModifier,
  workingHoursModifier,
} from 'modules/payroll_bundle/lib/utils'

export const AgreementInformationFields: IncidenceDetailsField[] = [
  {
    field: 'starts_on',
    translationKey: 'contract_start_date',
    valueModifier: dateModifier,
  },
  {
    field: 'start_on',
    translationKey: 'start_date',
  },
  {
    field: 'job_title',
    translationKey: 'job_title',
  },
  {
    field: 'job_catalog_level_name',
    translationKey: 'job_level',
  },
  {
    field: 'ends_on',
    translationKey: 'contract_end_date',
    valueModifier: dateModifier,
  },
  {
    field: 'trial_period_ends_on',
    translationKey: 'trial_period_ends_on',
    valueModifier: dateModifier,
  },
  {
    field: 'es_contract_type',
    translationKey: 'contract_type',
  },
  {
    field: 'es_working_day',
    translationKey: 'working_day',
  },
  {
    field: 'fr_contract_type_name',
    translationKey: 'contract_type',
  },
  {
    field: 'fr_work_type_name',
    translationKey: 'work_type',
  },
  {
    field: 'es_job_description',
    translationKey: 'job_description',
  },
  {
    field: 'es_education_level',
    translationKey: 'education_level',
  },
  {
    field: 'es_professional_category_name',
    translationKey: 'professional_category',
  },
  {
    field: 'es_cotization_group',
    translationKey: 'cotization_group',
    valueModifier: displayCotizationGroup,
  },
  {
    field: 'es_has_teleworking_contract',
    translationKey: 'has_teleworking_contract',
    valueModifier: booleanModifier,
  },
  {
    field: 'es_contract_observations',
    translationKey: 'contract_observations',
  },
  {
    field: 'es_contribution_type',
    translationKey: 'contribution_type',
  },
  {
    field: 'es_cno_occupation',
    translationKey: 'cno_occupation',
  },
  {
    field: 'es_regime',
    translationKey: 'regime',
  },
  {
    field: 'es_tariff_group',
    translationKey: 'tariff_group',
  },
  {
    field: 'es_occupation_code',
    translationKey: 'occupation_code',
  },
  {
    field: 'es_a3innuva_job_position',
    translationKey: 'a3innuva_job_position',
  },
  {
    field: 'fr_professional_category_name',
    translationKey: 'fr_professional_category',
  },
  {
    field: 'fr_mutual_name',
    translationKey: 'mutual',
  },
  {
    field: 'working_hours',
    extraField: 'working_hours_frequency',
    translationKey: 'working_hours',
    valueModifier: workingHoursModifier,
  },
  {
    field: 'working_week_days',
    translationKey: 'working_week_days',
    valueModifier: weekdaysModifier,
  },
  {
    field: 'salary_amount',
    extraField: 'salary_frequency',
    translationKey: 'salary_amount',
    valueModifier: salaryCurrencyFrequencyModifier,
  },
  {
    field: 'fr_coefficient',
    translationKey: 'coefficient',
  },
  {
    field: 'de_flat_rate_tax',
    translationKey: 'de_flat_rate_tax',
  },
  {
    field: 'de_activity_type',
    translationKey: 'de_activity_type',
  },
  {
    field: 'de_employment_type',
    translationKey: 'de_employment_type',
  },
  {
    field: 'de_personal_key_group_id',
    translationKey: 'de_personal_key_group_id',
  },
]
